import { TutorialDefinition } from './tutorial.model';

/**
 * Visite guidée de l'assistant Koffi (docs/TUTORIELS.md, docs/modules/ASSISTANT.md) : overlay de chat
 * monté à la racine de l'application, ouvert depuis l'en-tête, la barre latérale ou l'accueil.
 * Réservé aux organisations qui ont le module (SubscriptionFeaturesService.assistantEnabled) : le
 * bouton n'est affiché que dans ce cas. Aucun message n'est envoyé pendant la visite.
 * Les cibles du fil sont `optional` : sans elles (historique ouvert, conversation entamée), l'étape est sautée.
 */
export const ASSISTANT_OVERLAY_TOUR: TutorialDefinition = {
  id: 'assistant.overlay',
  module: 'assistant',
  title: 'Découvrir Koffi, votre assistant',
  version: 1,
  steps: [
    {
      title: 'Koffi, votre assistant',
      text: 'Koffi comprend une demande écrite ou parlée et agit dans vos modules : créer une tâche, réserver une salle, poser une présence, savoir qui est au bureau. Il est en bêta.',
    },
    {
      target: 'assistant.overlay.composer',
      title: 'Écrire votre demande',
      text: 'Tapez une phrase naturelle et validez avec <kbd>Entrée</kbd> (<kbd>Maj</kbd> + <kbd>Entrée</kbd> pour passer à la ligne). Tapez <kbd>/</kbd> pour choisir une action rapide dans une liste.',
      side: 'top',
      optional: true,
    },
    {
      target: 'assistant.overlay.mic',
      title: 'Parler plutôt qu’écrire',
      text: 'Cliquez sur le micro, dictez votre demande, puis cliquez de nouveau pour arrêter. Pendant que Koffi répond à voix haute, le micro est indisponible.',
      side: 'top',
      optional: true,
    },
    {
      target: 'assistant.overlay.suggestions',
      title: 'Des exemples pour commencer',
      text: 'Ces raccourcis s’adaptent à la page que vous consultez, par exemple « Mes tâches » ou « Réserver une salle ». Un clic lance une demande guidée : Koffi vous pose ses questions, vous répondez avec des boutons.',
      side: 'top',
      optional: true,
    },
    {
      title: 'Vous gardez la main',
      text: 'Koffi répond dans le fil. Quand il a besoin d’un choix (un projet, un autre créneau si une salle est prise), il propose des boutons. Avant une suppression (une tâche, une présence), il affiche une carte avec ce qui va être fait et deux boutons, « Confirmer » et « Annuler » : rien n’est supprimé tant que vous n’avez pas confirmé.',
    },
    {
      target: 'assistant.overlay.history',
      title: 'Retrouver une conversation',
      text: 'Cette icône ouvre l’historique de vos conversations : reprenez-en une ou commencez-en une nouvelle.',
      side: 'bottom',
      align: 'end',
      optional: true,
    },
    {
      target: 'assistant.overlay.privacy',
      title: 'Vos données',
      text: 'Vos demandes sont traitées par un service tiers (OpenAI). « En savoir plus » ouvre la politique de confidentialité.',
      side: 'top',
      optional: true,
    },
    {
      title: 'À vous de jouer',
      text: 'Essayez une demande simple, par exemple « Mes tâches ». <kbd>Échap</kbd> ferme la visite ; l’assistant reste ouvert.',
    },
  ],
};
